"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filtersOrder = exports.minYearsExpOptions = exports.getDiversityValue = exports.diversityOptions = exports.getCompany = exports.getSchoolRank = exports.currentCompanyOptions = exports.schoolRankOptions = exports.progressOptions = exports.timeWindowOptions = exports.getProgressTimestamp = exports.getProgressStage = void 0;
// cspell:ignore FAANG
const moment = require("moment");
const timeWindowOptions = [
    'Today',
    'Last 2 days',
    'This week',
    'Last 7 days',
    'Last 30 days',
    'Last 2 months',
    'Last 3 months',
    'Last 6 months',
    'Last 12 months',
    'Last 24 months',
    'Last 36 months'
];
exports.timeWindowOptions = timeWindowOptions;
const progressOptions = [
    'Positive Email Response',
    'Rocket Phone Screen',
    'Submitted to Client',
    'Client 1st Round',
    'Client 2nd Round',
    'Client Final Round',
    'Offer'
];
exports.progressOptions = progressOptions;
const schoolRankOptions = ['Top 10', 'Top 25', 'Top 50'];
exports.schoolRankOptions = schoolRankOptions;
const currentCompanyOptions = [
    'Top 50 VC backed startups',
    'All VC backed startups',
    'Top Accelerator startups',
    'All Accelerator startups',
    'FAANG Like',
    'Unicorns, US/CAN'
];
exports.currentCompanyOptions = currentCompanyOptions;
const diversityOptions = ['Female', 'LGBTQ', 'URM', 'Veteran'];
exports.diversityOptions = diversityOptions;
const minYearsExpOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15+'];
exports.minYearsExpOptions = minYearsExpOptions;
const filtersOrder = [
    'specificJobs',
    'timeWindow',
    'progress',
    'assignees',
    'excludedClients',
    'favoritesOnly',
    'tags',
    'blacklistedOnly',
    'visas',
    'disciplines',
    'profileGroup',
    'diversity',
    'csDegreeOnly',
    'schoolRank',
    'locations',
    'currentCompany',
    'minYearsExp',
    'keywords'
];
exports.filtersOrder = filtersOrder;
function getCompany(options) {
    return (options !== null && options !== void 0 ? options : []).length > 0 ? options.map(getCompanyPreset) : null;
}
exports.getCompany = getCompany;
function getCompanyPreset(option) {
    switch (option) {
        case 'Top 50 VC backed startups':
            return 'top-vcs';
        case 'All VC backed startups':
            return 'vcs';
        case 'Top Accelerator startups':
            return 'top-accelerators';
        case 'FAANG Like':
            return 'faang';
        case 'Unicorns, US/CAN':
            return 'unicorns us/can';
        case 'All Accelerator startups':
            return 'accelerators';
        default:
            return option.toLowerCase().replace(/[+()]/g, '');
    }
}
function getSchoolRank(option) {
    if (schoolRankOptions.indexOf(option) !== -1) {
        switch (option) {
            case 'Top 10':
                return '10';
            case 'Top 25':
                return '25';
            case 'Top 50':
                return '50';
        }
    }
    return null;
}
exports.getSchoolRank = getSchoolRank;
function getProgressTimestamp(option) {
    // tslint:disable:no-magic-numbers
    switch (option) {
        case 'Today':
            return moment().startOf('day').valueOf();
        case 'Last 2 days':
            return moment().startOf('day').subtract(1, 'd').valueOf();
        case 'This week':
            return moment().startOf('week').valueOf();
        case 'Last 7 days':
            return moment().subtract(7, 'd').startOf('day').valueOf();
        case 'Last 30 days':
            return moment().subtract(30, 'd').startOf('day').valueOf();
        case 'Last 2 months':
            return moment().subtract(2, 'months').startOf('day').valueOf();
        case 'Last 3 months':
            return moment().subtract(3, 'months').startOf('day').valueOf();
        case 'Last 6 months':
            return moment().subtract(6, 'months').startOf('day').valueOf();
        case 'Last 12 months':
            return moment().subtract(12, 'months').startOf('day').valueOf();
        case 'Last 24 months':
            return moment().subtract(24, 'months').startOf('day').valueOf();
        case 'Last 36 months':
            return moment().subtract(36, 'months').startOf('day').valueOf();
        default:
            return null;
        // tslint:enable:no-magic-numbers
    }
}
exports.getProgressTimestamp = getProgressTimestamp;
function getProgressStage(option) {
    switch (option) {
        case 'Positive Email Response':
            return 'being_scheduled';
        case 'Rocket Phone Screen':
            return 'rocket_screen_complete';
        case 'Submitted to Client':
            return 'awaiting_client_feedback';
        case 'Client 1st Round':
            return 'client_first_round';
        case 'Client 2nd Round':
            return 'client_middle_round';
        case 'Client Final Round':
            return 'client_second_round';
        case 'Offer':
            return 'offer';
        default:
            return null;
    }
}
exports.getProgressStage = getProgressStage;
function getDiversityValue(diversity, option) {
    if (diversity && diversity.indexOf(option) !== -1) {
        return true;
    }
    return false;
}
exports.getDiversityValue = getDiversityValue;
//# sourceMappingURL=candidates-search.js.map